import React from 'react';
import { IBooleanMattributesData } from '../mfrm-products-compare.props.autogenerated';
export interface IProductMattributeProps {
    mattributeName?: string | undefined,
    mattributeScore?: any | undefined,
    mattributeValue?: string | undefined,
    booleanMattributes?: IBooleanMattributesData[] | undefined;
}

export const ProductMattribute: React.FC<IProductMattributeProps> = (props) => {
    const { mattributeName, mattributeScore, mattributeValue, booleanMattributes} = props;
    const mattributescore = mattributeScore && Number(mattributeScore) / 2;
    if (booleanMattributes?.find(m => m?.mattributeName?.toLowerCase().trim() === mattributeName?.toLowerCase().trim())) {
        return (
            <div className='mattribute-container'>
                <h5 className='mattribute'>{mattributeName}</h5>
                {mattributeValue === '1' ? <span>YES</span> : <span>NO</span>}
            </div>
        );
    }
    return (
        <div>
            <h5 className='mattribute'>{mattributeName}</h5>
            <ul className='score'>
                {[...Array(5)].map((_, i) =>
                    i < mattributescore && i + 1 > mattributescore ?
                        (<li key={i}><div className='halffilled'></div></li>)
                        : i < mattributescore ? (<li key={i}><div className='filled'></div></li>)
                            : mattributescore === 0 || !mattributescore ? (<li key={i}><div className=''></div></li>)
                                : (<li key={i}><div className=''></div></li>)
                )}

            </ul>
        </div>
    );
};
